class ConfigureSimulatorController {
    constructor(ManageSimulatorServiceApi, ModalService, toastr, UtpProvisionSimServiceApi, SettingsExService, SimulationDataServiceApi, ScriptInjectionService, UserDetailsApi) {
        this.onModelUpdated = () => {
            if (!this.gridOptions.api) {
                return;
            }
            let model = this.gridOptions.api.getModel();
            this.gridOptions.api.sizeColumnsToFit();
        };
        this.popoverCellRenderer = (row) => {
            let tooltip = row.data.value;
            return this.createText(row.data.value, tooltip);
        };
        this.getRowData = (simResource) => {
            const rowData = [];
            if (!simResource.Url)
                return rowData;
            // Initial stream row
            rowData.push({ path: [simResource.Name], value: simResource.Url });
            /**
             * MQ: stream.wmq://hostname:1415;Channel=CHANNEL;ConsumerQueueName=;ConsumerQueueRemoteName=;MessageExpiry=0;ProducerQueueName=SNM.Q;ProducerQueueRemoteName=;QueueManager=queue.manager
             * TCP: stream.tcpip://localhost:5803;MessagePacking=prefixed:LengthEncoding=msbf:ByteCount=4;Mode=Server
             * ComModule: commodule.multiuser.stream:StreamTemplateResource=AcquirerSwitchTcpServer
             *
             * We can have either a colon or semi-colon splitting the key value pairs. For this UI we really don't care about why they are different
             * The stream uses a colon to delimit between host and port so we have to be careful when splitting
             * Using TCP example stream.tcpip://localhost:5803;MessagePacking=prefixed:LengthEncoding=msbf:ByteCount=4;Mode=Server
             *   Split on semi-colon (splitRes)
             *     stream.tcpip://localhost:5803
             *     MessagePacking=prefixed:LengthEncoding=msbf:ByteCount=4
             *     Mode=Server
             *   baseRes is split without = (baseRes)
             *     stream.tcpip://localhost:5803
             *   Remove stream from splitRes (splitResWithoutStream)
             *     MessagePacking=prefixed:LengthEncoding=msbf:ByteCount=4
             *     Mode=Server
             *   Join with colon (splitResWithoutStream)
             *     MessagePacking=prefixed:LengthEncoding=msbf:ByteCount=4:Mode=Server
             *   Split on colon (splitResWithoutStream)
             *     MessagePacking=prefixed
             *     LengthEncoding=msbf
             *     ByteCount=4
             *     Mode=Server
             */
            let splitRes = simResource.Url.split(';');
            if (splitRes.length === 1)
                splitRes = simResource.Url.split(':');
            const baseRes = splitRes.find((sr) => !sr.includes('='));
            rowData.push({ path: [simResource.Name, simResource.Type], value: baseRes });
            const splitResWithoutStream = splitRes.filter((sr) => sr !== baseRes).join(':').split(':');
            for (const splitResource of splitResWithoutStream) {
                const kvp = splitResource.split('=');
                rowData.push({ path: [simResource.Name, kvp[0]], value: kvp.length > 0 ? kvp[1] : '' });
            }
            return rowData;
        };
        this.gridOptions = {
            defaultColDef: {
                sortable: true,
                filter: 'text',
                resizable: true,
            },
            autoGroupColumnDef: {
                headerName: 'Name',
                minWidth: 30,
                width: 50,
                cellRendererParams: {
                    suppressCount: true
                }
            },
            columnDefs: [
                {
                    headerName: 'Value',
                    field: 'value',
                    minWidth: 300,
                    cellRenderer: this.popoverCellRenderer,
                    cellStyle: {
                        'white-space': 'nowrap'
                    }
                }
            ],
            onModelUpdated: this.onModelUpdated,
            onGridReady: (event) => {
                const data = [];
                for (const simResource of this.data.simMQs) {
                    data.push(...this.getRowData(simResource));
                }
                event.api.setRowData(data);
            },
            onRowDataChanged: (event) => {
                event.api.expandAll();
                event.api.sizeColumnsToFit();
            },
            suppressMovableColumns: true, // Added because of ag-grid bug see https://github.com/ceolter/ag-grid/issues/965#issuecomment-225857509
            angularCompileRows: true,
            treeData: true,
            getDataPath: (data) => data.path
        };
        this.$onInit = () => {
            this.init();
        };
        this.init = () => {
            this.data = {};
            this.pubicKeyState = {};
            this.isSupportUser = false;
            this.state = {
                showSpinner: true,
                tabs: {
                    MQ: {
                        visible: false,
                        active: false,
                        index: 0
                    },
                    validations: {
                        visible: false,
                        active: false,
                        index: 1
                    },
                    certificates: {
                        visible: false,
                        active: false,
                        index: 2
                    },
                    ICS: {
                        visible: false,
                        active: false,
                        index: 3
                    },
                    options: {
                        visible: false,
                        active: false,
                        index: 4
                    },
                    simulationData: {
                        visible: false,
                        active: false,
                        index: 5
                    }
                },
                activeTab: null,
                user: null
            };
            this.startLoading();
            this.sim = this.resolve.simulator;
            this.userId = this.resolve.userId;
            this.isSupportUser = this.resolve.isSupportUser;
            this.liveSimulationData = this.resolve.liveSimulationData;
            this.UserDetailsApi.get().then((response) => {
                let connectedUser = response.data;
                this.state.user = {
                    Id: connectedUser.Id,
                    Name: connectedUser.SingleSignOnDetails === null ? connectedUser.UserName : connectedUser.SingleSignOnDetails.LoginName
                };
                this.ManageSimulatorServiceApi.getSimulatorConfigs(this.userId, this.sim.Id).then((response) => {
                    let simConfig = response.data;
                    // As of OTSUTP-2735 only simulation data should be modifiable when the sim is running
                    this.data.simulationDataTypes = simConfig.SimulationDataTypes;
                    if (!this.liveSimulationData && !_.isNil(this.data.simulationDataTypes) && this.data.simulationDataTypes.length > 0) {
                        this.state.tabs.simulationData.visible = true;
                    }
                    this.data.icsQuestions = simConfig.ICSQuestions;
                    if (!_.isNil(this.data.icsQuestions) && this.data.icsQuestions.length > 0) {
                        this.state.tabs.ICS.visible = true;
                    }
                    if (!this.sim.IsRunning) {
                        this.data.simMQs = simConfig.Resources;
                        if (!_.isNil(this.data.simMQs) && this.data.simMQs.length > 0) {
                            this.state.tabs.MQ.visible = true;
                        }
                        this.data.simFlags = simConfig.ValidationFlags;
                        if (!_.isNil(this.data.simFlags) && this.data.simFlags.length > 0) {
                            this.state.tabs.validations.visible = true;
                        }
                        this.data.simulatorOptions = simConfig.SimulatorOptions;
                        if (!_.isNil(this.data.simulatorOptions) && this.data.simulatorOptions.length > 0) {
                            /* Show only if there is at least one unhidden */
                            if (_.some(this.data.simulatorOptions, ['Hidden', false])) {
                                this.state.tabs.options.visible = true;
                            }
                        }
                    }
                    this.SettingsExService.getCachedSettings().then((settings) => {
                        if (!settings.ShowValidationFlags) {
                            // Option overrides everything
                            this.state.tabs.validations.visible = false;
                        }
                        if (this.sim.PublicKeySupported) {
                            this.pubicKeyState.appSettings = settings;
                            this.UtpProvisionSimServiceApi.simUserModel(this.userId).then((response) => {
                                let simusermodel = response.data;
                                let activeSim = _.find(simusermodel.ActiveSims, (s) => {
                                    return s.SimulatorId === this.sim.Id;
                                });
                                this.pubicKeyState.selectedSim = activeSim;
                                this.pubicKeyState.user = { Id: this.userId, Roles: ['GroupTester'] };
                                this.pubicKeyState.showHeaderFooter = false;
                                // Do not show public key when the sim is running
                                this.state.tabs.certificates.visible = !this.sim.IsRunning;
                                this.setFirstEnabledTab();
                                this.endLoading();
                            });
                        }
                        else {
                            this.setFirstEnabledTab();
                            this.endLoading();
                        }
                    });
                });
            });
        };
        this.setFirstEnabledTab = () => {
            let firstEnabledTab = null;
            for (let key in this.state.tabs) {
                let tab = this.state.tabs[key];
                if (tab.visible) {
                    firstEnabledTab = tab;
                    break;
                }
            }
            if (!_.isNil(firstEnabledTab)) {
                this.state.activeTab = firstEnabledTab;
            }
            else {
                this.toastr.info('There is nothing configurable for ' + this.sim.Name);
                this.cancel();
            }
        };
        this.startLoading = () => {
            this.state.showSpinner = true;
        };
        this.endLoading = () => {
            this.state.showSpinner = false;
        };
        this.updateValidationFlag = (flag) => {
            /*Implement this method*/
        };
        this.saveSimulatorOptions = () => {
            let options = this.data.simulatorOptions;
            let illegalChars = false;
            for (let simOption of options) {
                if (this.ScriptInjectionService.isInjectedScript(simOption.Value)) {
                    this.toastr.error(simOption.DisplayName + ' contains illegal characters');
                    illegalChars = true;
                }
            }
            if (illegalChars) {
                return;
            }
            this.ManageSimulatorServiceApi.saveSimulatorOptions(this.userId, this.sim.Id, options).then((response) => {
                let result = response.data;
                if (result.errors.length > 0) {
                    for (let res of result.errors) {
                        this.toastr.error(res);
                    }
                }
                else {
                    this.toastr.info('Simulator options saved successfully.');
                }
            });
        };
        this.cancel = () => {
            this.dismiss();
        };
        this.ManageSimulatorServiceApi = ManageSimulatorServiceApi;
        this.ModalService = ModalService;
        this.toastr = toastr;
        this.SimulationDataServiceApi = SimulationDataServiceApi;
        this.UserDetailsApi = UserDetailsApi;
        this.UtpProvisionSimServiceApi = UtpProvisionSimServiceApi;
        this.SettingsExService = SettingsExService;
        this.ScriptInjectionService = ScriptInjectionService;
    }
    createText(data, tooltip) {
        let text = ['<span',
            'uib-popover="',
            tooltip,
            '"',
            'popover-animation',
            'popover-trigger="\'mouseenter\'"',
            'popover-placement="auto"',
            'popover-append-to-body="true"',
            '>',
            data,
            '</span>'
        ].join(' ');
        return text;
    }
}
angular.module('app').component('configureSimulator', {
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    },
    templateUrl: 'scripts/app/partials/GroupTester/ConfigureSimulator/configure-simulator.tpl.html',
    controllerAs: 'vm',
    controller: ConfigureSimulatorController
});
